"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var LvFalconNavigatorWithArrowBackButtons_1 = require("./LvFalconNavigatorWithArrowBackButtons");
var LvBritanniaNavigatorWithArrowBackButtons = /** @class */ (function (_super) {
    __extends(LvBritanniaNavigatorWithArrowBackButtons, _super);
    function LvBritanniaNavigatorWithArrowBackButtons(props) {
        var _this = _super.call(this, props) || this;
        _this.hidePageTitlesForPages = __spreadArray(__spreadArray([], _this.hidePageTitlesForPages, true), [
            "cancelCarCovers",
            "cancelPolicyReason",
            "cancellationReasonPage",
            "cancellationCoverPage",
            "paymentCancelCarCover",
            "editCoverTier"
        ], false);
        return _this;
    }
    return LvBritanniaNavigatorWithArrowBackButtons;
}(LvFalconNavigatorWithArrowBackButtons_1.default));
exports.default = LvBritanniaNavigatorWithArrowBackButtons;
//# sourceMappingURL=LvBritanniaNavigatorWithArrowBackButtons.js.map